import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';

type Props = {
  step?: number;
  title: string;
  description: string;
};

const StepTitle: React.FC<Props> = ({ step, title, description }) => {
  const { messages } = useTypedIntl();
  
  return (
    <div className="StepTitle space-y-[6px]">
      {step && (
        <div className="bg-primary-50 border border-primary-300 rounded-full px-[8px] py-[2px] flex items-center gap-x-[8px] w-fit">
          <div className="w-[8px] h-[8px] rounded-full bg-primary-600" />
          <div className="text-[14px] text-primary-600">{`${messages['common.step']} ${step}`}</div>
        </div>
      )}
      <div className="text-[22px]">{title}</div>
      <div className="text-[14px] text-neutral-500">{description}</div>
    </div>
  );
};

export default StepTitle;
